import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import ElementUI from 'element-ui'
import 'lib-flexible/flexible'
import 'element-ui/lib/theme-chalk/index.css'
import './static/icon/iconfont.css'
import progressive from 'progressive-image/dist/vue' // 引入渐进式图片加载
import VueLazyload from 'vue-lazyload'  // 引入图片懒加载
import MetaInfo from 'vue-meta-info'  // 更好的管理你的 app 里面的 meta 信息

Vue.use(MetaInfo)

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1
})

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(progressive, {
  removePreview: true,
  scale: true
})

new Vue({
  router,
  store,
  render: h => h(App),
  // mounted() {
  //   document.dispatchEvent(new Event('render-event'))
  // }
}).$mount('#app')
